import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabasePublicKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!supabaseUrl || !supabasePublicKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabasePulse = createClient(
  supabaseUrl,
  supabasePublicKey,
  {
    db: {
      schema: 'pulse'
    }
  }
);
